/*
 *   File : ipv-success.js
 *   Author URI : https://evoqins.com
 *   Description : Modal for showing payment status. 
 *   Integrations : null
 *   Version : v1.1
 */

import { useEffect } from "react";

import Icon from "../Icon/icon";

import style from '../../Styles/Components/cancel-sip.module.scss';

import { GradientButton } from "../Cta";

const AadhaarEsignOtpModal = (props) => {

    useEffect(() => {
        var my_modal = document.getElementById("aadhaar-esign");
        my_modal.addEventListener("hidden.bs.modal", () => {
            props.close();
        });
    }, []);

    return (
        <div className={`modal fade ${style.e_sip_modal}`}
            id="aadhaar-esign"
            tabIndex="-1"
            data-bs-backdrop="static"
            aria-labelledby="aadhaar-esign"
            aria-hidden="true">
            <div className={`modal-dialog position-relative modal-dialog-centered ${style.e_dialog1}`}>
                <div className={`modal-content bg-modal p-4 ${style.e_content} `}>
                    <Icon icon="close"
                        size={24}
                        data-bs-dismiss="modal"
                        className={`position-absolute cursor-pointer e-modal-close-btn ${style.e_close}`} />
                    <span id="close-modal" data-bs-dismiss="modal" className='d-none'></span>
                    <div className="text-center">
                        <img src={require('../../Assets/Images/Portfolio/e-sign-otp-notice.png')}
                            alt="E-Sign Otp Notice"
                            width={72}
                            height={72} />
                    </div>
                    <div className="row pb-4">
                        <div className="col-12 text-center">
                            <h5 className="color-eerie-black e-poppins-medium e-font-18 mt-3">
                                Aadhaar e-Sign OTP Notice
                            </h5>
                            <p className="color-black e-poppins-regular e-font-16 mb-0  text-center">
                                The OTP for Aadhaar e-Sign will be sent to the mobile number linked with your Aadhaar. If you do not have access to that number, please select 'Manual Form Download' to proceed.
                            </p>
                        </div>
                    </div>
                    <div className="row pt-2 justify-content-center">
                        <div className="col-8 text-center">
                            <GradientButton label="Understood"
                                className="padding-12px-tb "
                                cancel="modal"
                                onPress={props.handleProceed} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AadhaarEsignOtpModal;